import React, { Component } from 'react'; 
import $ from 'jquery';
import Box from '@mui/material/Box';
import {DebounceInput} from 'react-debounce-input';
import moment from 'moment';

export default class FormNote extends Component {
	constructor(props) {
        super(props);
        this.state={
            //q9:'',
        }
        this.shoot = this.shoot.bind(this);
		this.addNote = this.addNote.bind(this);
    }
    
    shoot(event) {
		//console.log('value',event.target.value)
        //this.setState({q9:event.target.value})
        //this.props.func(this.props.data.fieldId,event.target.value);
    }
	
	addNote = () => {
		let username = localStorage.getItem('username'); 
		let id = this.props.data.fieldId;
		let inputValue = document.querySelector('input[name="formNote"]').value;
		let date = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		date = moment(date).format('MM-DD-YYYY HH:mm:ss');
		
		//const element = document.getElementById("formNoteBox");
		//element.append("-"+inputValue+"    "+date+"    "+username+"\n");
		//document.querySelector('input[name="formNote"]').value = '';
		//let formNoteBox = document.querySelector('input[name="formNoteBox"]').value;

		let kioskResponse = this.props.data.kioskResponse;
		let res = kioskResponse.get(id)
		if(res){
			//res += "\n-"+inputValue+"    "+date+"    "+username;
			res = "-" + inputValue + "    " + date + "    " + username +"\n"+ res;
		}else{
			res = "-"+inputValue+"    "+date+"    "+username;
		}
		
		console.log('kioskResponse->',res);
		
		this.props.func(this.props.data.fieldId,res);
		document.querySelector('input[name="formNote"]').value = '';
		
    }
	
    render(){
        const {data} = this.props;
        let id = data.fieldId;
		let kioskResponse = data.kioskResponse;
		//console.log('kioskResponse->',kioskResponse);
        return (
            
			<Box>
			{/* <DebounceInput element="textarea" debounceTimeout={4000} className={'form-control'} rows="8" id="formNoteBox" onChange={this.shoot}/> */}
			<textarea element="textarea" className={'form-control'} rows="8" id="formNoteBox" value={kioskResponse.get(id)} disabled></textarea> 
			
			<div className="input-group-append mr-top">
				<input name="formNote" type="text" className={'form-control'} />
				<button type="button" className="btn btn-primary input-group-text" style={{ backgroundColor:'blue',color:'white'}} onClick={this.addNote}>
					<span className="glyphicon glyphicon-plus"> + Add </span>
				</button>
			</div>
			
			</Box>
        );
    }
}